import { Component } from '@angular/core';
import { HomeFacade } from '../../facades/home.facade';

/**
 * Contenedor del home. Provee {@link HomeFacade} para que `section-start`
 * y `section-property` compartan una única carga de últimas propiedades.
 */
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    providers: [HomeFacade],
})
export class DashboardComponent {
}
